// extracted by mini-css-extract-plugin
export default {"pdtc":"index_pdtc__UCtEx","text":"index_text__XwY0k","flag":"index_flag__pFQni"};